import { MotorParsers } from 'ts/types';
import escapeCharactersInObjectStrings, {
  escapeSpecialChars,
  escapeHTML,
} from 'utils/encoder/encoder';

const ESCAPES_BY_TYPE = {
  ECARE: escapeHTML,
  CONCERTO: escapeSpecialChars,
  DEFAULT: escapeSpecialChars,
} as const;

const escapeChars = (
  payload: any,
  cms: keyof typeof ESCAPES_BY_TYPE = 'DEFAULT',
) => escapeCharactersInObjectStrings(payload, [], ESCAPES_BY_TYPE[cms]);

const emptyParser = (payload: any) => payload;

const moveFranceParser = (payload: any) => {
  const parsedPayload = { ...payload };
  const escapedPayload = escapeChars(parsedPayload);
  return escapedPayload;
};

const moveTurkeyParser = (payload: any) => {
  const parsedPayload = { ...payload };
  const escapedPayload = escapeChars(parsedPayload, 'ECARE');
  return escapedPayload;
};

const parsers: Record<MotorParsers, (payload: any) => any> = {
  none: emptyParser,
  moveFrance: moveFranceParser,
  moveTurkey: moveTurkeyParser,
} as const;

export default parsers;
